import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { throwError } from 'rxjs';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;

@Injectable()
export class AppleCertificateService {

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private datePipe: DatePipe,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers()).pipe(
    map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
      return res.body;
    }), catchError(this.handleError));

  }

  pageContent(dataurl) {
    return this.fetchJSON(dataurl);
  }
  createPageLoadProperties(url, section2) {
    const dataLayer = {};
    if (url === 'REMOVEMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/appleCertificate/removemodal.html';
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_APPLECERTIFICATE_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_APPLECERTIFICATE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR] = ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION] = 'Apple Certificate';
     dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = section2;
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    }
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
  pageHtml(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => test)
      ,catchError( this.handleError ));
  }

  getAppleSummary(scenarios) {
    let appleUrl;
    appleUrl = this.utilityService.getEnvConfig().getAppleSummary + '?detail=true';
    return this.fetchJSON(appleUrl);
  }

  deleteAppleCertificate(appleId) {
    return this.httpClientService.authorizedDelete(this.utilityService.getEnvConfig().deleteAppleCertificate +
    '?appleId=' + appleId)
    .pipe(
       map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
      return res.body;
    })
      ,catchError( this.handleError ));
  }

  generateCSR(appleId,appleRenewal) {
    let url= this.utilityService.getEnvConfig().generateCSR;
     if(appleRenewal=='true'){
      url= url +'?flowType=renew';
      console.log("renewal"+url);
    }
    else{
      url= url +'?flowType=new';
      console.log("new"+url);
    }
    return this.fetchJSON(url + '&appleId=' + appleId);
  }

  downloadCSR(appleRenewal) {
    let url= this.utilityService.getEnvConfig().generateCSR;
     if(appleRenewal=='true'){
      url= url +'?flowType=renew';
      console.log("renewal"+url);
    }
    else{
      url= url +'?flowType=new';
      console.log("new"+url);
    }
    return this.fetchJSON(url + '&download=true');
  }

  makeCSRFile = function (text) {
    const data = new Blob([text], {type: 'text/plain'});
    const textFile = window.URL.createObjectURL(data);
    return textFile;
  };

  uploadAppleCertficate(data,appleRenewal) {
    let url= this.utilityService.getEnvConfig().uploadAppleCertificate;
    if(appleRenewal=='true'){
      url= url +'?flowType=renew';
      console.log("renewal"+url);
    }
    else{
      url= url +'?flowType=new';
      console.log("new"+url);
    }
    return this.httpClientService.post(url, {pem: data}, this.get_headers())
    .pipe(
       map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
      return res.body;
    })
      ,catchError( this.handleError ));
  }

  setAppleInfo(appleId, csr) {
    sessionStorage.setItem('AppleCertificate', JSON.stringify({
      appleId: appleId,
      csr: csr
    }));
  }

  getAppleInfo() {
    return sessionStorage.getItem('AppleCertificate') ? JSON.parse(sessionStorage.getItem('AppleCertificate')) : false;
  }

  removeAppleInfo() {
    sessionStorage.removeItem('AppleCertificate');
  }

  handleError = (error) => {
    return throwError(error);
  }
  getpreviousRoute() {
    return sessionStorage.getItem('previousRoute');
  }
  getlandingPageRoute() {
    return sessionStorage.getItem('landingPageRoute');
  }
}
